/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { licensesValidate } from "../../funcs/licensesValidate.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.ValidateLicenseRequestEntity$inboundSchema,
};

export const tool$licensesValidate: ToolDefinition<typeof args> = {
  name: "licenses-validate",
  description: `Validates a license key or instance.

Verify if a license key is valid and active for a specific instance. Check activation status and expiration.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await licensesValidate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
